import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { fetchProfile } from "../Services/profile/profileservice";
import { removeToken } from "../utils/tokenUtils";
import { logout } from "../Services/authService";
import useInactivityLogout from "../Services/InactiveLogout";

const AuthWrapper = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  // hook is ALWAYS called
  const isInactive = useInactivityLogout({
    timeout: 900000, // 10 minutes
    disabled: location.pathname === "/Session-expired",
  });

  // 🔐 auth check (token / API)
  useEffect(() => {
    if (location.pathname === "/Session-expired") return;

    const checkAuthentication = async () => {
      const token = Cookies.get("authTokenUser");

      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const response = await fetchProfile();
        if (response?.data?.message === "Unauthenticated.") {
          removeToken();
          logout();
          setIsAuthenticated(false);
        }
      } catch {
        logout();
        setIsAuthenticated(false);
      }
    };

    checkAuthentication();
  }, [location.pathname]);

  useEffect(() => {
    if (!isInactive) return;
    if (location.pathname === "/Session-expired") return;

    logout();
    navigate("/Session-expired", { replace: true });
  }, [isInactive, location.pathname, navigate]);

  // 🚪 route protection
  if (!isAuthenticated && location.pathname !== "/Session-expired") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthWrapper;
